var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1617005996895,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1642,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.791373 64.325028l319.093479 0 0 320.733838-319.093479 0 0-320.733838Z",
    "p-id": 1643
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M640.090818 64.325028l319.093479 0 0 320.733838-319.093479 0 0-320.733838Z",
    "p-id": 1644
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.791373 638.399805l319.093479 0 0 320.734862-319.093479 0 0-320.734862Z",
    "p-id": 1645
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M640.090818 638.399805l319.093479 0 0 320.734862-319.093479 0 0-320.734862Z",
    "p-id": 1646
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGroup);
export default __webpack_public_path__ + "static/media/icon-group.5b89b4f2c2aa3322625b202e7a357816.svg";
export { ForwardRef as ReactComponent };